function initOnlyFindzCountdowns(scope) {
  scope.querySelectorAll('[data-onlyfindz-countdown]').forEach((countdown) => {
    if (countdown.dataset.bound === 'true') return;

    const endDate = countdown.getAttribute('data-end-date');
    if (!endDate) return;

    const target = new Date(endDate);
    if (Number.isNaN(target.getTime())) {
      countdown.hidden = true;
      return;
    }

    const dayNode = countdown.querySelector('[data-countdown-days]');
    const hourNode = countdown.querySelector('[data-countdown-hours]');
    const minuteNode = countdown.querySelector('[data-countdown-minutes]');

    const render = () => {
      const diff = Math.max(0, target.getTime() - Date.now());
      const totalMinutes = Math.floor(diff / 60000);
      const days = String(Math.floor(totalMinutes / 1440)).padStart(2, '0');
      const hours = String(Math.floor((totalMinutes % 1440) / 60)).padStart(2, '0');
      const minutes = String(totalMinutes % 60).padStart(2, '0');

      if (dayNode) dayNode.textContent = days;
      if (hourNode) hourNode.textContent = hours;
      if (minuteNode) minuteNode.textContent = minutes;

      if (diff <= 0) {
        window.clearInterval(timer);
      }
    };

    render();
    const timer = window.setInterval(render, 60000);
    countdown.dataset.bound = 'true';
  });
}

function initOnlyFindzSlider(scope) {
  const slider = scope.querySelector('[data-onlyfindz-slider]');
  if (!slider || slider.dataset.bound === 'true') return;

  const slides = Array.from(slider.querySelectorAll('.onlyfindz-home__slide'));
  const dots = Array.from(slider.querySelectorAll('[data-onlyfindz-dot]'));
  const prev = slider.querySelector('[data-onlyfindz-prev]');
  const next = slider.querySelector('[data-onlyfindz-next]');

  if (slides.length < 2) {
    slider.dataset.bound = 'true';
    return;
  }

  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;

  // Slides are laid out like train cars: each sits at (index - activeIndex)
  // full card-widths apart (shortest signed distance, so navigation wraps
  // both ways). Card width + gap come from CSS custom properties so the
  // peek amount can change per breakpoint without touching this math.
  // During a drag the whole train is shifted by the live pointer delta in
  // pixels, so the neighbouring slide is already visible, following the
  // pointer, before the gesture ever completes.
  const shortestOffset = (index) => {
    const length = slides.length;
    let diff = index - activeIndex;
    if (diff > length / 2) diff -= length;
    if (diff < -length / 2) diff += length;
    return diff;
  };

  let cachedStep = 0;

  function refreshStep() {
    const width = slider.clientWidth || 1;
    const styles = getComputedStyle(slider);
    const parseAmount = (raw) => {
      const value = raw.trim();
      return value.endsWith('%') ? (parseFloat(value) / 100) * width : parseFloat(value) || 0;
    };
    const slideWidth = parseAmount(styles.getPropertyValue('--onlyfindz-slide-width') || '100%');
    const gap = parseAmount(styles.getPropertyValue('--onlyfindz-slide-gap') || '0px');
    cachedStep = slideWidth + gap;
  }

  function position(dragPx) {
    const shift = dragPx || 0;
    slides.forEach((slide, index) => {
      const offset = shortestOffset(index);
      slide.style.transform = `translateX(${offset * cachedStep + shift}px)`;
    });
  }

  function render(index) {
    const newIndex = (index + slides.length) % slides.length;
    const oldOffsets = slides.map((_, i) => shortestOffset(i));
    activeIndex = newIndex;
    const newOffsets = slides.map((_, i) => shortestOffset(i));

    // A slide whose shortest-path offset flips sides (e.g. -1 to +1, the
    // lone "odd one out" with only 3 slides in the loop) would otherwise
    // sweep across the whole track when the transition kicks in. Snap those
    // instantly instead of animating them; the two slides genuinely involved
    // in the step always move by exactly one position and keep the smooth
    // transition, so the visual order never appears to shuffle.
    const jumping = slides.filter((_, i) => Math.abs(newOffsets[i] - oldOffsets[i]) > 1);
    if (jumping.length) {
      jumping.forEach((slide) => { slide.style.transition = 'none'; });
      void slider.offsetHeight; // commit the no-transition state before the jump
    }

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === activeIndex);
    });
    refreshStep();
    position();

    if (jumping.length) {
      void slider.offsetHeight; // commit the instant jump before re-enabling the transition
      jumping.forEach((slide) => { slide.style.transition = ''; });
    }
  }

  window.addEventListener('resize', () => {
    refreshStep();
    position();
  }, { passive: true });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      render(Number(dot.getAttribute('data-onlyfindz-dot')) || 0);
    });
  });

  if (prev) {
    prev.addEventListener('click', () => render(activeIndex - 1));
  }

  if (next) {
    next.addEventListener('click', () => render(activeIndex + 1));
  }

  // Drag / swipe navigation (mouse, pen and touch). The current slide tracks
  // the pointer 1:1 while dragging, and the adjacent slide (already parked
  // right next to it) is revealed live in the same motion. On release the
  // gesture either completes (CSS-transitions into place) or snaps back.
  const DISTANCE_THRESHOLD_RATIO = 0.18;
  const VELOCITY_THRESHOLD = 0.5; // px/ms, flung swipes commit early
  const INTENT_THRESHOLD = 8;
  let pointerId = null;
  let dragging = false;
  let intentLocked = false;
  let horizontalIntent = false;
  let startX = 0;
  let startY = 0;
  let deltaX = 0;
  let lastX = 0;
  let lastT = 0;
  let velocity = 0;
  let suppressNextClick = false;

  // The full-bleed hero banners (and the campaign CTA) are real <a> links so
  // they work without JS and are crawlable/accessible. That means a drag
  // gesture starts on top of a link every time. Only <button> (arrows/dots)
  // opts out of drag tracking up front; <a> still starts tracking, and any
  // click it would have fired is cancelled after the fact if the gesture
  // turned out to be a genuine horizontal drag (see the capturing click
  // listener below) — so tapping still navigates, dragging still swipes.
  const endSwipe = () => {
    if (!dragging) return;
    dragging = false;
    slider.classList.remove('is-dragging');
    slider.style.userSelect = '';
    if (pointerId !== null) {
      try { slider.releasePointerCapture(pointerId); } catch (e) {}
    }
    pointerId = null;

    if (horizontalIntent && deltaX !== 0) {
      suppressNextClick = true;
      const width = slider.clientWidth || 1;
      const passedDistance = Math.abs(deltaX) > width * DISTANCE_THRESHOLD_RATIO;
      const passedVelocity = Math.abs(velocity) > VELOCITY_THRESHOLD;
      if (passedDistance || passedVelocity) {
        render(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
      } else {
        render(activeIndex);
      }
    }
    deltaX = 0;
    velocity = 0;
    intentLocked = false;
    horizontalIntent = false;
  };

  slider.addEventListener('click', (event) => {
    if (!suppressNextClick) return;
    suppressNextClick = false;
    event.preventDefault();
    event.stopPropagation();
  }, true);

  slider.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button')) return;
    if (event.button !== undefined && event.button !== 0) return;
    dragging = true;
    intentLocked = false;
    horizontalIntent = false;
    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    deltaX = 0;
    lastX = event.clientX;
    lastT = performance.now();
    velocity = 0;
    refreshStep();
  });

  slider.addEventListener('pointermove', (event) => {
    if (!dragging || event.pointerId !== pointerId) return;
    deltaX = event.clientX - startX;
    const deltaY = event.clientY - startY;

    if (!intentLocked && (Math.abs(deltaX) > INTENT_THRESHOLD || Math.abs(deltaY) > INTENT_THRESHOLD)) {
      intentLocked = true;
      horizontalIntent = Math.abs(deltaX) > Math.abs(deltaY);
      if (horizontalIntent) {
        slider.classList.add('is-dragging');
        slider.style.userSelect = 'none';
        // Capturing the pointer only now — not on pointerdown — matters: once
        // captured, the browser retargets the eventual pointerup/click to the
        // capturing element (this div) instead of whatever was under the
        // finger/cursor. Captured immediately on pointerdown, a plain tap on
        // the <a> would retarget its own click away from itself and silently
        // eat the navigation even without any drag happening. Deferring the
        // capture until real horizontal movement is confirmed keeps a tap's
        // click on its original target (the link fires normally) while still
        // giving a genuine drag reliable tracking outside the element bounds.
        try { slider.setPointerCapture(pointerId); } catch (e) {}
      }
    }

    if (horizontalIntent) {
      event.preventDefault();
      const now = performance.now();
      const dt = now - lastT;
      if (dt > 0) velocity = (event.clientX - lastX) / dt;
      lastX = event.clientX;
      lastT = now;
      position(deltaX);
    }
  }, { passive: false });

  slider.addEventListener('pointerup', endSwipe);
  slider.addEventListener('pointercancel', endSwipe);
  slider.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse') endSwipe();
  });
  slider.addEventListener('dragstart', (event) => event.preventDefault());

  // First paint: the raw CSS defaults park every non-active slide at the
  // same spot (translateX(100%)), so establishing each one's real resting
  // position for the first time must not animate — otherwise the slide
  // that belongs on the left visibly sweeps in from the right on load.
  slides.forEach((slide) => { slide.style.transition = 'none'; });
  render(activeIndex);
  void slider.offsetHeight;
  slides.forEach((slide) => { slide.style.transition = ''; });
  slider.dataset.bound = 'true';
}

function initOnlyFindzRails(scope) {
  scope.querySelectorAll('[data-onlyfindz-rail]').forEach((rail) => {
    if (rail.closest('.template-product')) {
      rail.dataset.bound = 'true';
      return;
    }

    if (rail.dataset.bound === 'true') return;

    const shell = rail.closest('.onlyfindz-home__rail-shell');
    const prev = shell?.querySelector('[data-onlyfindz-rail-prev]');
    const next = shell?.querySelector('[data-onlyfindz-rail-next]');

    if (!shell || !prev || !next) {
      rail.dataset.bound = 'true';
      return;
    }

    const items = () => Array.from(rail.children).filter((item) => item instanceof HTMLElement);

    const updateState = () => {
      const useRail = window.matchMedia('(max-width: 989px)').matches;
      const list = items();
      const maxScrollLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const canScroll = useRail && maxScrollLeft > 4 && list.length > 0;
      let canScrollPrev = false;
      let canScrollNext = false;

      if (canScroll) {
        const railRect = rail.getBoundingClientRect();
        const firstRect = list[0].getBoundingClientRect();
        const lastRect = list[list.length - 1].getBoundingClientRect();

        canScrollPrev = firstRect.left < railRect.left - 2 && rail.scrollLeft > 1;
        canScrollNext = lastRect.right > railRect.right + 2 && rail.scrollLeft < maxScrollLeft - 1;
      }

      shell.classList.toggle('is-rail-active', useRail);
      shell.classList.add('is-rail-ready');
      prev.hidden = !canScrollPrev;
      next.hidden = !canScrollNext;
      prev.disabled = !canScrollPrev;
      next.disabled = !canScrollNext;
    };

    const currentIndex = () => {
      const list = items();
      let closest = 0;
      let minDist = Infinity;
      list.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - rail.scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    };

    const goTo = (index) => {
      const list = items();
      const clamped = Math.max(0, Math.min(list.length - 1, index));
      const item = list[clamped];
      if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    prev.addEventListener('click', () => {
      goTo(currentIndex() - 1);
    });

    next.addEventListener('click', () => {
      goTo(currentIndex() + 1);
    });

    rail.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState, { passive: true });
    window.addEventListener('load', updateState, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        updateState();
      });
      resizeObserver.observe(rail);
      items().forEach((item) => resizeObserver.observe(item));
    }

    updateState();
    window.requestAnimationFrame(() => {
      updateState();
      window.requestAnimationFrame(updateState);
    });
    rail.dataset.bound = 'true';
  });
}

function initOnlyFindzCategoryRail(scope) {
  scope.querySelectorAll('[data-onlyfindz-category-rail]').forEach((rail) => {
    if (rail.dataset.bound === 'true') return;

    const shell = rail.closest('.onlyfindz-home__category-rail-shell');
    const prev = shell?.querySelector('[data-onlyfindz-category-prev]');
    const next = shell?.querySelector('[data-onlyfindz-category-next]');

    const cards = () => Array.from(rail.children);

    const currentIndex = () => {
      let closest = 0;
      let minDist = Infinity;
      cards().forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - rail.scrollLeft);
        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      });
      return closest;
    };

    const goTo = (index) => {
      const list = cards();
      const clamped = Math.max(0, Math.min(list.length - 1, index));
      const card = list[clamped];
      if (card) card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };

    const updateArrows = () => {
      const maxScrollLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft >= maxScrollLeft - 4;
    };

    if (prev) {
      prev.addEventListener('click', () => {
        goTo(currentIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        goTo(currentIndex() + 1);
      });
    }

    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    // Mouse/pen click-and-drag scrolling (with momentum) is handled globally
    // by assets/drag-to-scroll.js, which binds to [data-onlyfindz-category-rail].

    updateArrows();
    rail.dataset.bound = 'true';
  });
}

function trimOnlyFindzGridToFullRows(grid) {
  const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
  const visible = Array.from(grid.querySelectorAll('[data-onlyfindz-loadmore-item]:not([hidden])'));
  const remainder = visible.length % columns;
  if (remainder > 0) {
    visible.slice(visible.length - remainder).forEach((item) => item.setAttribute('hidden', ''));
  }
}

function initOnlyFindzLoadMore(scope) {
  const BATCH_SIZE = 15;

  scope.querySelectorAll('[data-onlyfindz-loadmore-trigger]').forEach((trigger) => {
    if (trigger.dataset.bound === 'true') return;
    trigger.dataset.bound = 'true';

    const initialTarget = document.getElementById(trigger.getAttribute('data-onlyfindz-loadmore-target'));
    const initialGrid = initialTarget ? initialTarget.querySelector('[data-onlyfindz-loadmore-grid]') : null;
    if (initialGrid) trimOnlyFindzGridToFullRows(initialGrid);

    trigger.addEventListener('click', async () => {
      if (trigger.disabled) return;

      const targetId = trigger.getAttribute('data-onlyfindz-loadmore-target');
      const sectionId = trigger.getAttribute('data-onlyfindz-loadmore-section');
      const target = targetId ? document.getElementById(targetId) : null;
      const grid = target ? target.querySelector('[data-onlyfindz-loadmore-grid]') : null;
      const actions = trigger.closest('.onlyfindz-home__loadmore-actions');
      if (!target || !grid) return;

      const revealFromPool = (count) => {
        const hidden = Array.from(grid.querySelectorAll('[data-onlyfindz-loadmore-item][hidden]'));
        const toReveal = hidden.slice(0, count);
        toReveal.forEach((item) => item.removeAttribute('hidden'));
        return toReveal.length;
      };

      let revealed = revealFromPool(BATCH_SIZE);
      let nextPage = trigger.getAttribute('data-onlyfindz-loadmore-next-page');

      if (revealed < BATCH_SIZE && nextPage && sectionId) {
        trigger.disabled = true;
        trigger.classList.add('is-loading');

        try {
          while (revealed < BATCH_SIZE && nextPage) {
            const url = new URL(window.location.href);
            url.searchParams.set('page', nextPage);
            url.searchParams.set('section_id', sectionId);

            const response = await fetch(url.toString());
            if (!response.ok) throw new Error('load-more request failed');
            const html = await response.text();

            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newGrid = parsed.getElementById(targetId)?.querySelector('[data-onlyfindz-loadmore-grid]');
            const newItems = newGrid ? Array.from(newGrid.children) : [];
            newItems.forEach((item) => grid.appendChild(item));

            revealed += revealFromPool(BATCH_SIZE - revealed);

            const newTrigger = parsed.querySelector('[data-onlyfindz-loadmore-trigger]');
            nextPage = newTrigger ? newTrigger.getAttribute('data-onlyfindz-loadmore-next-page') : null;
          }
        } catch (e) {
          // keep whatever was already revealed/appended so far; button stays clickable to retry
        }

        trigger.disabled = false;
        trigger.classList.remove('is-loading');
      }

      if (nextPage) {
        trigger.setAttribute('data-onlyfindz-loadmore-next-page', nextPage);
        trimOnlyFindzGridToFullRows(grid);
      } else {
        trigger.removeAttribute('data-onlyfindz-loadmore-next-page');
      }

      const stillHidden = grid.querySelector('[data-onlyfindz-loadmore-item][hidden]') !== null;
      if (!stillHidden && !nextPage) {
        actions?.remove();
      }
    });
  });
}

function initMarketplaceHome(scope) {
  initOnlyFindzCountdowns(scope);
  initOnlyFindzSlider(scope);
  initOnlyFindzRails(scope);
  initOnlyFindzCategoryRail(scope);
  initOnlyFindzLoadMore(scope);
}

function bootstrapMarketplaceHome() {
  document.querySelectorAll('[data-onlyfindz-home]').forEach(initMarketplaceHome);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapMarketplaceHome);
} else {
  bootstrapMarketplaceHome();
}

document.addEventListener('shopify:section:load', (event) => {
  const scope = event.target.querySelector('[data-onlyfindz-home]');
  if (scope) initMarketplaceHome(scope);
});
